import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import TranslatedText from "../components/TranslatedText";

const Admin = () => {
  const [messageList, setMessageList] = useState([]);

  // Fetch messages from localStorage when the component mounts
  useEffect(() => {
    const storedMessages =
      JSON.parse(localStorage.getItem("contactForm")) || [];
    setMessageList(storedMessages);
  }, []);

  const deleteMessage = (index) => {
    let storedMessages = JSON.parse(localStorage.getItem("contactForm"));
    storedMessages.splice(index, 1);
    localStorage.setItem("contactForm", JSON.stringify(storedMessages));
    setMessageList(storedMessages);
  };

  const deleteAllMessages = () => {
    localStorage.removeItem("contactForm");
    setMessageList([]);
  };

  return (
    <Box className="activ-box" component="main" sx={{ p: 3 }}>
      <Button
        variant="outlined"
        size="medium"
        onClick={deleteAllMessages}
        style={{
          borderRadius: "25px",
          borderStyle: "double",
          color: "#2875B0",
          position: "relative",
          marginTop: "3%",
        }}
      >
        <TranslatedText defaultText="Slett alle meldinger" />
      </Button>
      {messageList.length === 0 ? (
        <p>
          <TranslatedText defaultText="Ingen meldinger funnet." />
        </p>
      ) : (
        <>
          <h3>
            <TranslatedText defaultText="Registrerte meldinger:" />
          </h3>
          {messageList.map((message, index) => (
            <div key={index}>
              <p>
                <strong>
                  <TranslatedText defaultText="Navn:" />
                </strong>{" "}
                {message.name}
              </p>
              <p>
                <strong>
                  <TranslatedText defaultText="E-post:" />
                </strong>{" "}
                {message.email}
              </p>
              <p>
                <strong>
                  <TranslatedText defaultText="Melding:" />
                </strong>{" "}
                {message.message}
              </p>
              <Button onClick={() => deleteMessage(index)}>
                Slett denne meldingen
              </Button>
              <hr />
            </div>
          ))}
        </>
      )}
    </Box>
  );
};

export default Admin;
